"use client";

/**
 * @Author: JulienBigot7 julien@generation-internet.biz
 * @Date: 2024-10-22 11:53:11
 * @LastEditors: JulienBigot7 julien@generation-internet.biz
 * @LastEditTime: 2024-10-22 12:03:41
 * @FilePath: src/app/(main)/(public)/layout.tsx
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */
import { c as _c } from "react/compiler-runtime";
import React from "react";
import PublicBottomNav from "@/components/global/public-bottom-nav";
function Layout(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <PublicBottomNav />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <>{children}{t1}</>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export default Layout;